import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBilling } from '../contexts/BillingContext';

/**
 * Bloqueia rotas quando a mensalidade está vencida (após dias de tolerância).
 * Rotas isentas: /billing, /login, /master.
 */
export const BillingBlocker = ({ children }) => {
  const { isBlocked } = useBilling();
  const location = useLocation();

  const exempt = ['/billing', '/login', '/master', '/entrar', '/super-admin'];
  const isExempt = exempt.some((p) => location.pathname.startsWith(p));

  if (isBlocked && !isExempt) {
    return <Navigate to="/billing" replace state={{ blocked: true }} />;
  }
  return children;
};
